export const getHeader = (): Record<string, string> => {
    const token = localStorage.getItem("auth_token");
    const header = {
        Authorization: token ?? "",
        origin: "http://admin.hodlperk.com/"
    };
    return header;
};
